import axios from 'axios'
let result = ''
const instance = axios.create({
  baseURL:process.env.NODE_ENV == 'development'? '/dev-api' : process.env.VUE_APP_BASE_API,
  timeout: 20000,
})
instance.interceptors.request.use( (config)=>{
  result =  config.responseType
  return config
}, (error)=>{
  return Promise.reject(error)
})

instance.interceptors.response.use( (response)=>{
  if(response.status == 200 && result==  "blob") {
    return response.data
  }
  if(response.status == 200 && response.data.code == 200) {
    return response.data
  }else {
    return Promise.reject(response.data.msg)
  }

}, (error)=>{
  return Promise.reject(error)
})

export default instance
